import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/img/icon/arrow-left.svg';
import _imports_1 from '@/img/icon/home.svg';
const _withScopeId = n => (_pushScopeId("data-v-6eb1e3cf"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "crumbs"
};
const _hoisted_2 = {
  class: "crumbs__inner"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: " back"
}, null, -1));
const _hoisted_4 = {
  class: "home"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "home"
}, null, -1));
const _hoisted_6 = {
  class: "crumbs-list"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goBack && $options.goBack(...args)),
    class: "back"
  }, [_hoisted_3, _createTextVNode(" Назад ")]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_router_link, {
    to: "/rol-shop/"
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  })]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paths, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "crumbs-item",
      key: item
    }, [_createVNode(_component_router_link, {
      to: item.path
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
      _: 2
    }, 1032, ["to"])]);
  }), 128))])])]);
}